import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { TouchSequence } from 'selenium-webdriver';
import { Constant } from "../../shared/model/Constant";
import { ProductService } from "../../service/product.service";


import { AdminService } from '../../service/admin.service';
import { CurrencyPipe } from '@angular/common';





@Component({
  selector: 'app-product-management',
  templateUrl: './product-management.page.html',
  styleUrls: ['./product-management.page.scss'],
})
export class ProductManagementPage implements OnInit {

  errorMessage: string = '';
  companyId: any;
  company: any;
  provider: any;
  tradeName: String;
  loading: HTMLIonLoadingElement;
  categories: any;
  name: String;
  selectedCompany: any = null;
  document: any;
  socialReason: String;
  companies: any[] = [];
  showTable = false;
  showProvidersTable = false;
  selectAll = false;
  showHead = true;
  providerName: any;
  typesSettlementId: number;
  selectedProviderId: number;
  txt: any;
  products: any[] = [];
  selectedProduct: any;
  step: number = 1;
  isStep2Enabled: boolean = false;
  isStep3Enabled: boolean = false;
  providers: any[] = [];
  selectedProvider: any;
  productForm: FormGroup;
  configProductForm: FormGroup;
  providerId: any;
  productId: number; //almacena el Id del producto creado para enviar su configuracion
  userId: any;
  commissionCategories: any;
  commissionTypes: any;
  typeProducts: any;
  productTaxes: any;              //mostrara los impuestos disponinles, es decir los que el usuario no tiene registrados y no ha seleccionado, a medida que se añadan o eliminen impuestos la lista ira variando
  productTaxesAux: any [] = [];   //almacenara todos los impuestos existentes con el fin de restaurar la lista original
  taxes:any [] = [];                //arreglo que se enviara al back con los productos que se modificaran
  registerProductTaxes: any [] = [];      //arreglo para almacenar los impuestos registrados para un producto
  registerProductTaxesAux: any [] = [];   //almacenara todos los impuestos existentes para un usuario con el fin de restaurar la lista
  taxesToDelete: any [] = [];            //almacenara los impuestos existentes que se van a eliminar
  taxesToReAdd: any [] = [];              //almacena los impuestos existentes que el usuario envio a eliminar pero quiere volver a añadirlos
  validAmount = true;
  validAmountRange = true;
  validDate = true;
  messageDate: any;
  minimumValue: any;                 //almacena valor numerico de campo Monto Minimo
  maximumValue: any;                  //almacena valor numerico de campo Monto Maximo
  editingProduct = false;              //indica si el producto es nuevo (false) o se esta editando (true)
  submited = false;
  marginValue: any;
  marginValueNoFormat: any;
  commissionsTypeId: any;
  commissionsTypesOptions: any[] = [{name: 'Comisión Fija', value:1}, {name: 'Comisión Porcentual', value:2}];  //los tipos de comision a listar.


  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    public alertController: AlertController,
    public loadingController: LoadingController,
    public toastController: ToastController,
    private productService: ProductService,
    private currencyPipe: CurrencyPipe,


  ) { }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: 'Por favor espera...',
      spinner: 'circles'
    });
    await this.loading.present();
    await Promise.all([
      this.getProductCategoryId(),
      this.getCommissionCategory(),
      this.getProductsTypes(),
      this.getTypeTaxes(),
      this.getCommissionType()
    ]);
    this.loading.dismiss();
    this.productForm = this.fb.group({
      providerId: [this.selectedProviderId || '', Validators.required],
      productId: [''],
      name: ['', Validators.required],
      description: [''],
      productCategoryId: ['', Validators.required], // Nuevo campo para la categoría del producto
      typesSettlementId: ['', Validators.required], // Nuevo campo para la categoría de comisión
      productTypeId: ['', Validators.required], // Nuevo campo para el tipo de producto
      commissionsTypeId: ['', Validators.required], //campo para tipo de comision
      hasTaxes: ['', Validators.required],  //campo para impuesto (si/no)
      hasRestriction: ['', Validators.required], //campo para restriccion (si/no)
      minimumSalesValue: [''],
      maximumSalesValue: [''],
      initialSchedule: [''],
      finalTime: [''],
      typeTaxesId: [''],
      marginValue: ['', Validators.required],
    });
  }

  initForm() {
    this.productForm = this.fb.group({
      provider: ['', Validators.required],
      name: ['', Validators.required],
      description: [''],
    });

  }

  getProductCategoryId() {
    this.loading.present();
    this.productService.getProductCategoryId().subscribe((res: any) => {
      this.categories = res.filter(category => category.state === 1);
      this.loading.dismiss();
    });
  }

  getCommissionCategory() {       //trae los tipos de liquidacion
    this.loading.present();
    this.productService.getCommissionCategory().subscribe((res: any) => {
      this.commissionCategories = res.filter(commission => commission.state === 1);
      this.loading.dismiss();
    });
  }

  getCommissionType() {
    this.loading.present();
    this.productService.getCommissionType().subscribe((res: any) => {
      this.commissionTypes = res.filter(commissionTypes => commissionTypes.state === 1);
      this.loading.dismiss();
    });
  }

  getProductsTypes() {
    this.loading.present();
    this.productService.getProductsTypes().subscribe((res: any) => {
      this.typeProducts = res.filter(type => type.state === 1);
      this.loading.dismiss();
    });
  }

  getTypeTaxes() {
    this.loading.present();
    this.productService.getTypeTaxes().subscribe((res: any) => {
      this.productTaxes = res.filter(productTaxes => productTaxes.state === 1);
      this.loading.dismiss();
      this.productTaxesAux = [...this.productTaxes];
    });
  }


  onAddProductClick(provider: any) {
    this.selectedProviderId = provider.providerId;
    this.selectedProvider = provider;
    this.products = [];
    if (this.productForm) {
      this.productForm.patchValue({ providerId: this.selectedProviderId });
    }
    this.loadProducts(this.selectedProviderId);
    this.isStep2Enabled = true;
    this.step = 2;
    this.goToStep(2);
  }

  enableNextStep(nextStep: number) {
    if (nextStep === 2) {
      this.isStep2Enabled = true;
    } else if (nextStep === 3) {
      this.isStep3Enabled = true;
    }
  }

  loadProducts(providerId: number) {
    this.productService.getProductsByProviderId(providerId).subscribe(
      (response: any) => { // Asumiendo que la respuesta podría no estar correctamente tipada.
        if (Array.isArray(response)) {
          this.products = response.map(product => {
            return {
              ...product,
              categoryName: this.getCategoryName(product.productCategoryId),
              typeProductName: this.getTypeProductName(product.productTypeId),
              commissionCategoryName: this.getCommissionCategoryName(product.typesSettlementId),
            };
          });
        } else {
          console.error('La respuesta no es un array:', response);
        }
      },
      (error) => {
        console.error('Error al cargar productos:', error);
      }
    );
  }

 async getTaxesByProductId(productId: number) {
    
    const response = await this.productService.getActiveTaxesByProduct(productId).toPromise();
    this.registerProductTaxesAux = Object.values(response);
    if (this.registerProductTaxesAux.length !== 0) {
        try {
          this.registerProductTaxesAux.forEach(tax => {
            const foundTaxIndex = this.productTaxes.findIndex(productTax => productTax.typeTaxesId === tax.typeTaxesId);
              if (foundTaxIndex !== -1) {
                const foundTax = this.productTaxes[foundTaxIndex];
                this.registerProductTaxes.push(foundTax); // Añadir el impuesto encontrado a registerProductTaxes ya que son los que se mostraran
                this.productTaxes.splice(foundTaxIndex, 1); // Eliminar el impuesto encontrado de productTaxes
              }
          });
        } catch (error) {
          console.log('Error al cargar impuestos:', error);
        }
    } else {
      console.log('No se encontraron impuestos registrados para el producto con Id: ', productId);
    }
}

  getCategoryName(productCategoryId: number): string {
    return this.categories.find(c => c.productCategoryId === productCategoryId)?.name || 'Desconocido';
  }

  getTypeProductName(productTypeId: number): string {
    return this.typeProducts.find(t => t.productTypeId === productTypeId)?.name || 'Desconocido';
  }

  getCommissionCategoryName(typesSettlementId: number): string {
    return this.commissionCategories.find(cc => cc.typesSettlementId === typesSettlementId)?.name || 'Desconocido';
  }


  onToggleChange(product) {
    const initialState = product.initialState;

    product.changed = !product.changed;
    if ((product.state === 1 && !product.changed) || (product.state === 2 && product.changed)) {
      product.changed = !product.changed;
    }
    product.state = product.changed ? (product.state === 1 ? 2 : 1) : product.state;
    product.changed = product.state !== initialState;


    console.log('Toggle changed for product:', product);
  }




  goToStep(stepNumber: number) {
    this.step = stepNumber;
  }

  goToNextStep() {
    this.step = 2;
  }

  async saveProduct(productForm: FormGroup) {
    console.log('Formulario válido:', this.productForm.valid);
    this.submited = true;
    if (this.productForm.valid) {
        console.log('Form valido');
        const product = {
          productId: productForm.value.productId,
          name: productForm.value.name,
          description: productForm.value.description,
          productCategoryId: productForm.value.productCategoryId,
          typesSettlementId: productForm.value.typesSettlementId,
          productTypeId: productForm.value.productTypeId,
          providerId: this.selectedProviderId,
          commissionsTypeId: productForm.value.commissionsTypeId,
          hasRestriction: productForm.value.hasRestriction,
          taxes: productForm.value.hasTaxes,
          marginValue: this.marginValueNoFormat ? this.marginValueNoFormat : 0,
          minimumSalesValue: (productForm.value.hasRestriction === 1 && this.minimumValue > 0) ? this.minimumValue : 0,
          maximumSalesValue: (productForm.value.hasRestriction === 1 && this.maximumValue > 0) ? this.maximumValue : 0,
          initialSchedule: (productForm.value.hasRestriction === 1 && productForm.value.initialSchedule !== '') ? this.addSecondsTime(productForm.value.initialSchedule) : null || null,
          finalTime: (productForm.value.hasRestriction === 1 && productForm.value.finalTime !== '') ? this.addSecondsTime(productForm.value.finalTime) : null || null,
        }
      
         console.log('Producto a registrar', product);

        try {
          this.loading.dismiss();
          const productSave: any = await this.productService.createProducts(product).toPromise(); 
          this.productId = productSave.productId; //extrae el ID del producto registrado
          console.log('product Id', this.productId);
          this.presentToast('El producto ha sido registrado con éxito');
        } catch (error) {
          console.warn('Error al registrar el producto');
        }      
        await new Promise(resolve => setTimeout(resolve, 2000));
        this.taxesToDelete.forEach(elemen => {              //agrega los impuestos que se van a eliminar al arreglo que envia los impuestos al backend
          if (!this.taxes.includes(elemen)) {
             this.taxes.push(elemen); }
        });
        this.taxesToReAdd.forEach(element => {            //elimina los impuestos que el usuario decidio no eliminar del arreglo que se envia al backend
          if(this.taxes.some(tax => tax.typeTaxesId === element.typeTaxesId)) {
            const index = this.taxes.indexOf(element);
            this.taxes.splice(index,1);
          }
        })
        const ProductTaxes = this.taxes.map(producTax => ({
          productId: this.productId,
          typeTaxesId: producTax.typeTaxesId,
        }));
        if (ProductTaxes.length > 0) {
           this.productService.registerTaxes(ProductTaxes).subscribe(response => {
           this.presentToast(response);
          },error => {
            console.warn('Error al guardar impuestos:', error);
          });
        } else {
          console.log('hay impuestos seleccionados para ser registrados');
        }
        await new Promise(resolve => setTimeout(resolve, 2000));
        console.log('Producto guardado', product);
        this.resetStep3();
        this.loadProducts(this.selectedProviderId);
        this.isStep2Enabled = true;
        this.step = 2;
        this.goToStep(2);
        this.submited = false;
    } else {
      this.presentAlert('Por favor asegúrate de completar todos los campos antes de continuar.');
    }
    
  }

   async selectProductForEditing(product: any = null) {
    this.selectedProduct = product;
    this.isStep3Enabled = true; // Asegurar que el Step 3 esté habilitado
    this.step = 3; // Navegar al Step 3
    if (product) {
      this.editingProduct = true;
      console.log('producto a editar: ', product);
      this.productForm.patchValue({                           // Llenar el formulario con los datos del producto seleccionado para editar
        productId: product.productId,
        providerId: product.providerId || '',
        name: product.name || '',
        description: product.description || '',
        productCategoryId: product.productCategoryId || '',
        typesSettlementId: product.typesSettlementId || '',
        productTypeId: product.productTypeId || '',
        commissionsTypeId: product.commissionsTypeId || '',
        hasRestriction: product.hasRestriction ,
        minimumSalesValue: product.minimumSalesValue || '',
        maximumSalesValue: product.maximumSalesValue || '',
        initialSchedule: product.initialSchedule || '',
        finalTime: product.finalTime || '', 
        hasTaxes: product.taxes || '',
        marginValue: product.marginValue || '',
      });
      await this.getTaxesByProductId(product.productId);      //traigo los impuestos relacionados al Id producto
    } else {
      this.editingProduct = false;
      this.productForm.reset({                  // Restablecer el formulario para la creación de un nuevo producto
        providerId: this.selectedProviderId,
        productId: '', 
        name: '',
        description: '',
        productCategoryId: '',
        typesSettlementId: '',
        productTypeId: '',
        commissionsTypeId: '',
        hasTaxes: '',
        hasRestriction: '',
        minimumSalesValue: '',
        maximumSalesValue: '',
        initialSchedule: '',
        finalTime: '',
        typeTaxesId: '',
        marginValue: '',

      });
      this.taxes = [];
    }
    console.log('Se esta editando un producto?', this.editingProduct);
  }

  async addTax(taxToAdd: any) {
    if(taxToAdd === null || !taxToAdd){
    } else {
      if(this.registerProductTaxesAux.some(item => item.typeTaxesId === taxToAdd.typeTaxesId)) {            //SI ENTRA EN EL IF QUIERE DECIR QUE EL IMPUESTO ESTA REGISTRADO COMO ACTIVO Y EN EL FORMULARIO EL USUARIO LO ELIMINO NUEVAMENTE LO DESEA AGREGAR 
        this.taxesToDelete = this.taxesToDelete.filter(item => item.typeTaxesId !== taxToAdd.typeTaxesId);        //se quita el impuesto del arreglo de impuestos a eliminar ya que no se va a modificar
        this.productTaxes = this.productTaxes.filter(tax => tax.typeTaxesId !== taxToAdd.typeTaxesId);        //se quita de la lista de impuestos disponibles para ser agregados
        this.taxesToReAdd.push(taxToAdd);
      }
        this.taxes.push(taxToAdd);
        this.productTaxes = this.productTaxes.filter(tax => tax.typeTaxesId !== taxToAdd.typeTaxesId);
    }
  }
  
  async deleteTax(index: number) {
    let toDelete = this.taxes[index];
    if (toDelete !== null) {  
      this.taxes.splice(index, 1);
      this.productTaxes.push(toDelete);
      if(this.taxesToReAdd.includes(toDelete)) {
        this.taxesToReAdd = this.taxesToReAdd.filter(tax => tax.typeTaxesId !== toDelete.typeTaxesId);
        this.taxesToDelete.push(toDelete);
      }
    }
  }

  async deleteCurrentTax(index: number) {
    let toDelete = this.registerProductTaxes[index];
    if ( toDelete !== null) {
      this.registerProductTaxes.splice(index, 1);
      this.taxesToDelete.push(toDelete);
      this.productTaxes.push(toDelete);
    }
  }

  addSecondsTime(timeString) {
    console.log('Agregando segundos a:', timeString);
    return (timeString + ':00').substring(0,8); // Agregar segundos siempre, pero siempre devuelve HH:mm:ss
    }

  
  validateOnlyAmount() { 
    if (this.productForm.get('minimumSalesValue').value) {
      let amountNumbermin = this.productForm.get('minimumSalesValue').value;
      amountNumbermin = amountNumbermin.replace(/\D/g, '').substring(0,13);
      amountNumbermin = amountNumbermin.split("$").join('');
      amountNumbermin = amountNumbermin.split(",").join('');
      const auxMinimumSalesValue = Number(amountNumbermin.split(".").join(''));
      const formatedValueMin = this.currencyPipe.transform(auxMinimumSalesValue, 'COP', 'symbol-narrow', '1.0-0');
      this.productForm.get('minimumSalesValue').setValue(formatedValueMin);
      this.minimumValue = this.productForm.get('minimumSalesValue').value.replace(/[^\d]/g, '');
    }
  
    if (this.productForm.get('maximumSalesValue').value) {
      let amountNumbermax = this.productForm.get('maximumSalesValue').value;
      amountNumbermax = amountNumbermax.replace(/\D/g, '').substring(0,13);          
      amountNumbermax = amountNumbermax.split("$").join('');
      amountNumbermax = amountNumbermax.split(",").join('');
      const auxMaximumSalesValue = Number(amountNumbermax.split(".").join(''));
      const formatedValuemax = this.currencyPipe.transform(auxMaximumSalesValue, 'COP', 'symbol-narrow', '1.0-0');
      this.productForm.get('maximumSalesValue').setValue(formatedValuemax);
      this.maximumValue = this.productForm.get('maximumSalesValue').value.replace(/[^\d]/g, '');

    }
    if(this.maximumValue !== null && this.minimumValue !== null) {
      const maxValue = parseFloat(this.maximumValue);
      const minValue = parseFloat(this.minimumValue);
      this.validAmount = minValue < maxValue;
    }
  }

  add () {    //agrega % al final de el valor para mostrar en pantalla (SE GUARDA EN UNA VARIABLE DIFERENTE A LA QUE SE ENVIA PARA REGISTRAR)
    if(this.productForm.get('commissionsTypeId').value === 1) {
      if (this.productForm.get('marginValue').value.length > 0 ) {
        let amountLimitMin = this.productForm.get('marginValue').value;
        if (!amountLimitMin.includes('%')) {
            amountLimitMin = amountLimitMin + '%';
            this.productForm.get('marginValue').setValue(amountLimitMin);
            console.log('se aplico el %');
        } 
      } 
    }
  }

  clear() {
    this.productForm.get('marginValue').setValue('');
  }

  validateRange (){     /*METODO PARA CONTROLAR LA LONGITUD DE LOS CAMPOS, VALIDAR QUE LOS VALORES SEAN COHERENTES Y MOSTRAR FORMATO DE COP*/
    const commissionTypeId = this.productForm.get('commissionsTypeId').value;
    let value = '';
    if (commissionTypeId === 2) {             //PARA COMISION FIJA
      if(this.productForm.get('marginValue').value) {
        let amountLimitMin = this.productForm.get('marginValue').value;
        amountLimitMin = amountLimitMin.replace(/\D/g, '').substring(0,10);         
        amountLimitMin = amountLimitMin.split("$").join('');
        amountLimitMin = amountLimitMin.split(",").join('');
        const auxMinimumSalesValue = Number(amountLimitMin.split(".").join(''));
        const formatedValuemin = this.currencyPipe.transform(auxMinimumSalesValue, 'COP', 'symbol-narrow', '1.0-0');
        this.productForm.get('marginValue').setValue(formatedValuemin);
        this.marginValueNoFormat = this.productForm.get('marginValue').value.replace(/[^\d]/g, ''); //(SE GUARDA EN UNA VARIABLE DIFERENTE A LA QUE SE ENVIA PARA REGISTRAR)
      }
    } else if (commissionTypeId === 1) {      //PARA COMISION PORCENTUAL
      if(this.productForm.get('marginValue').value) {
        let amountLimitMin = this.productForm.get('marginValue').value;
        if(amountLimitMin.includes('.')){
          value = amountLimitMin.replace(/[^\d.]+/g, '')  // Elimina caracteres no numéricos ni puntos y agrupa varios puntos en uno
                          .replace(/(\.\d*?)\..*/, '$1').substring(0,4);
        } else {
          value = amountLimitMin.replace(/\D/g, '').substring(0,2);

        }
        this.productForm.get('marginValue').setValue(value);
        this.marginValueNoFormat = this.productForm.get('marginValue').value.replace(/[^\d]/g, '');

      }

    }
    /*
    if(this.commissionMaxLimitValue !== null && this.marginValueNoFormat !== null) {    METODO PARA VALIDAR QUE LOS VALORES DE UN RANGO NO SE SOLAPEN 
      const maxValue = parseFloat(this.commissionMaxLimitValue);
      const minValue = parseFloat(this.marginValueNoFormat);
      this.validAmountRange = minValue < maxValue;
    }*/
  }

  validateTimeInitial(value: any) {

    if (this.productForm.get('finalTime').value !== '' && this.productForm.get('finalTime').value !== null) {
      if(value > this.productForm.get('finalTime').value) {
          this.validDate = false;
          this.messageDate = 'La hora inicial debe ser menor a la hora final';
      } else if (value === this.productForm.get('finalTime').value) {
        this.validDate = false;
        this.messageDate = 'La hora inicial no puede ser igual a la hora final';
      } else if (value < this.productForm.get('finalTime').value) {
        this.validDate = true;
        this.messageDate = '';
      }
    } else {
      console.log('Una de las fechas es null, Inicial: ',this.productForm.get('initialSchedule').value, ', Final: ', this.productForm.get('finalTime').value);
    }
  }

  validateTimeFinal (value: any) {

    if (this.productForm.get('initialSchedule').value !== '' && this.productForm.get('initialSchedule').value !== null) {
      if (value < this.productForm.get('initialSchedule').value) {
          this.validDate = false;
          this.messageDate = 'La hora final debe ser mayor a la hora inicial';
      } else if (this.productForm.get('initialSchedule').value === value) {
        this.validDate = false;
          this.messageDate = 'La hora final no puede ser igual a la hora inicial';
      } else {
        this.validDate = true;
        this.messageDate = '';
      }
    } else {
      console.log('Una de las fechas es null, Inicial',this.productForm.get('initialSchedule').value, ', Final: ', this.productForm.get('finalTime').value);
    }
  }

  findProvider(form: NgForm) {
    this.showProvidersTable = false;
    if (form.valid) {
      const searchCriteria = {
        tradeName: this.providerName,
        providerId: this.providerId

      };
      const isAnyFieldFilled = Object.values(searchCriteria).some(value => value);
      if (isAnyFieldFilled) {
        this.adminService.findProvider(searchCriteria).subscribe(
          (results: any) => {
            this.providers = results.map(provider => ({
              ...provider,
              state: provider.state.toString()
            }));
            this.showProvidersTable = true;
            this.errorMessage = '';
          },
          error => {
            this.errorMessage = 'Error al buscar el proveedor';
            this.showProvidersTable = false;
          }
        );
      } else {
        this.adminService.getProviders().subscribe(
          (results: any) => {
            this.providers = results.map(provider => ({
              ...provider,
              state: provider.state.toString()
            }));
            this.showProvidersTable = true;
            this.errorMessage = '';
          },
          error => {
            this.errorMessage = 'Error al buscar el proveedor';
            this.showProvidersTable = false;
          }
        );
          if(form.value.providerId) {   //VALIDAR SI SE ESTA USANDO
            console.log('Hay providerId? ', form.value.providerId);
            const providerId = form.value.providerId;
        this.adminService.getProviderById(providerId).subscribe(
          data => {
            console.log('Respuesta del servidor:', data);
            this.errorMessage = '';
          },
          error => {
            console.error('Error al obtener el proveedor:', error);
            this.errorMessage = error.error.message || 'Error al buscar el proveedor';
            this.presentAlert(error.error.message || 'Error al buscar el proveedor');
          }
        );
          }
        
      }
    }
  }

  async presentAlert(errorMessage: string) {
    const alert = await this.alertController.create({
      header: 'Error',
      message: errorMessage,
      buttons: ['OK']
    });

    await alert.present();
  }

  async presentToast(txt: string) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  onSegmentChange() {
    if (this.step === 1) {
      this.resetStep1();
    }
    if (this.step === 3) {
       this.resetStep3();
    }
  }

  resetStep1() {
    this.showHead = true;
    this.showProvidersTable = false;
    this.providerId = null;
    this.providerName = null;
    this.providers = [];
  }

  resetStep3() {
    this.productForm.reset({
      providerId: this.selectedProviderId,
      productId: '', 
      name: '',
      description: '',
      productCategoryId: '',
      typesSettlementId: '',
      productTypeId: '',
      commissionsTypeId: '',
      hasTaxes: '',
      hasRestriction: '',
      minimumSalesValue: '',
      maximumSalesValue: '',
      initialSchedule: '',
      finalTime: '',
      typeTaxesId: ''
    });
    this.isStep3Enabled = false;
    this.selectedProduct = null;
    this.editingProduct = false;
    this.registerProductTaxes = [];
    this.registerProductTaxesAux = [];
    this.taxesToDelete = [];
    this.taxesToReAdd = [];
    this.clearTaxes();
    this.clearRestrictions();
  }

  clearTaxes() {
    if (this.editingProduct) {
      this.taxes = [];
      this.registerProductTaxes = [];
      this.taxesToDelete = [];
      this.taxesToReAdd = [];
      this.productTaxes = [...this.productTaxesAux];
    } else {
      this.taxes = [];
      this.productForm.get('typeTaxesId').reset();
      this.productTaxes = [...this.productTaxesAux];
    }

  }

  clearRestrictions() {
      this.validAmount = true;
      this.validDate = true;
      this.minimumValue = null;
      this.maximumValue = null;
    if(!this.editingProduct){
      this.productForm.get('minimumSalesValue').setValue(null);
      this.productForm.get('maximumSalesValue').setValue(null);
      this.productForm.get('initialSchedule').setValue(null);
      this.productForm.get('finalTime').setValue(null); 
    } else {
      this.productForm.get('minimumSalesValue').setValue(this.selectedProduct.minimumSalesValue);
      this.productForm.get('maximumSalesValue').setValue(this.selectedProduct.maximumSalesValue);
      this.productForm.get('initialSchedule').setValue(this.selectedProduct.initialSchedule);
      this.productForm.get('finalTime').setValue(this.selectedProduct.finalTime); 
    }
  }



}
